import { supabaseConfigurado } from '../supabase/cliente'
import { environment } from '../../../environments/environment'

/** Verificamos conectividad real contra Supabase antes de sincronizar. */
export async function hayConexionReal(timeoutMs = 3000): Promise<boolean> {
  if (!supabaseConfigurado) return navigator.onLine // modo demo: no hay backend real que pingear
  if (!navigator.onLine) return false // sin adaptador de red activo, ni intentamos pedir al backend

  const controlador = new AbortController()
  const temporizador = setTimeout(() => controlador.abort(), timeoutMs)
  try {
    // cache: 'no-store' evita que el navegador responda con un 200 cacheado de cuando si habia red.
    await fetch(`${environment.supabaseUrl}/auth/v1/health`, {
      method: 'GET',
      signal: controlador.signal,
      cache: 'no-store',
    })
    return true
  } catch {
    return false
  } finally {
    clearTimeout(temporizador)
  }
}

/**
 * Confirmamos conectividad dos veces con una pausa entre medio: justo al apagar el wifi puede
 * quedar un instante una conexion "tibia" (DNS o socket ya abierto) que deja pasar un solo intento
 * aunque ya no haya red real. Exigir dos aciertos separados evita subir datos en esa ventana.
 */
export async function hayConexionEstable(pausaMs = 1200): Promise<boolean> {
  if (!(await hayConexionReal())) return false
  await new Promise((r) => setTimeout(r, pausaMs))
  return hayConexionReal()
}
